

















import {Component, Prop, Vue} from "vue-property-decorator";

@Component
export default class AppVideo extends Vue {

    @Prop({required: true})
    public videoIds: any;

    videoUrl(id) {
        return 'https://www.youtube.com/embed/' + id;
    }

    playlistUrl() {
        return `http://www.youtube.com/watch_videos?&video_ids=` + this.videoIds.join(',');
    }
}
